import React from 'react';
import {Link} from 'react-router-dom';
import _ from "lodash";
import DateSince from '../../../components/Date';
import Avatar from '../../../components/Avatar';
import Views from '../../../components/Views';
import Answers from '../../../components/Answers';
import createLink from "../../../../libs/createLink";
import Dotdotdot from "react-dotdotdot";
import {separateurNumber} from '../../../../libs/helper';

const ForumCard = (props) => {
    let title = props.title;
    title = title.charAt(0).toUpperCase() + title.substring(1).toLowerCase();
    if (title.length > 60) {
        title = title.substring(0, 60) + '...';
    }
    let hasOwner = props.owner !== null && props.owner._id;
    let dateCreated = _.get(props, 'lastComment.createdAt') || "";
    return (
        <div className="card card-article-small">
            <div className="wrapper">
                <div className="topline p-16 pt-24">
                    <div>
                        <Link className="title-topic" to={createLink("forumTopic", {category : {slug : props.forum.slug, _id : props.forum._id}, topic : {_id : props._id, slug : props.slug}})}>
                            <Dotdotdot clamp={2} useNativeClamp={false}>
                                {title}
                            </Dotdotdot>
                        </Link>
                        <div className="forum-name"><Link className="title-forum"
                                                                    to={createLink("forumCategory", {category : {slug : props.forum.slug, _id : props.forum._id}})}>{props.forum && props.forum.name}</Link>
                                    </div>
                        <span className="text small medium-grey">
                            <DateSince
                                date={dateCreated}
                                prefix={true}
                                currentFormat={true}
                            />
                        </span>
                    </div>
                </div>
                <div className="content">
                    {hasOwner ? (<div className="user">
                        <div className="infos">
                            <div className="username-time">
                                Par <Link to={createLink("userProfile", props.owner)}>
                                {props.owner.username}&nbsp;
                            </Link>
                            </div>
                        </div>
                        <Link to={createLink("userProfile", props.owner)}>
                            <Avatar className="user-thumb" avatar={props.owner.profile.avatar}
                                    gender={props.owner.profile.gender} alt=""/>
                        </Link>
                    </div>) : (<div className="topline">
                            <div className="infos">
                                <div className="username-time">
                                    Par &nbsp; {props.authorName}
                                </div>
                            </div>
                            <div>
                                <Avatar className="user-thumb" gender={"guest"} alt=""/>
                            </div>
                        </div>
                    )}

                </div>
                <div className="footer">
                    <div className="subjects"><Views value={props.count && (separateurNumber(props.count.view) || 0)}/></div>
                    <Answers value={props.count && (props.count.comment || 0)}/>
                </div>
            </div>
        </div>
    )
};

export default ForumCard;
